import { IsNotEmpty } from 'main/common/validation/decorators/IsNotEmpty'
import { IsString } from 'main/common/validation/decorators/IsString'
import { IsEmail } from 'main/common/validation/decorators/IsEmail'
import { NotContainsSpace } from 'main/common/validation/decorators/NotContainsSpace'
import { FormModel } from 'main/common/form-state-manager/FormModel'

/**
 * VALIDADOR
 * Define campos / validacao pra form de login.
 */
export class UserLoginFormValidator extends FormModel {

    @NotContainsSpace()
    @IsString()
    @IsNotEmpty()
    schema: string

    @NotContainsSpace()
    @IsString()
    @IsNotEmpty()
    password: string

    @IsEmail()
    @IsNotEmpty()
    email: string

    constructor(initialValues?: Partial<UserLoginFormValidator>) {
        super()
        Object.assign(this, initialValues)
    }
}
